import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { PersonProfileAudit } from '../../+models/person-profile-audit.model';

@Component({
  selector: 'sd-portal-person-profile-audit-list',
  templateUrl: './person-profile-audit-list.component.html',
  styleUrls: ['./person-profile-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileAuditListComponent implements OnInit {
  @Input() personId: number;
  @Input() loading: boolean;
  @Input() personProfileAudits: PersonProfileAudit[];

  @Output() loadPersonProfile = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPersonProfile.emit(this.personId);
  }

  onNextPage() {
    this.nextPage.emit(this.personId);
  }
}
